import EsriJSON from 'ol/format/EsriJSON';
import { tile as tileStrategy } from 'ol/loadingstrategy';
import VectorSource, { type LoadingStrategy } from 'ol/source/Vector';
import { createXYZ } from 'ol/tilegrid';
import { normalizeLayerUrl } from '../rendering/layerUrl.ts';

export interface IArcGisVectorSourceOptions {
  /** Strategia di caricamento; default: per tile 512px */
  strategy?: LoadingStrategy;
}

/**
 * VectorSource per un layer ArcGIS REST vettoriale: interroga
 * l'endpoint `/query?f=json` del layer per l'extent richiesto.
 */
export function createArcGisVectorSource(
  rawUrl: string,
  options: IArcGisVectorSourceOptions = {},
): VectorSource {
  const baseUrl = normalizeLayerUrl(rawUrl);

  return new VectorSource({
    format: new EsriJSON(),
    url(extent) {
      // ArcGIS Server vuole solamente la parte numerica del SRID
      const srid = 102_100;
      return (
        baseUrl +
        '/query/?f=json&' +
        'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
        encodeURIComponent(
          '{"xmin":' +
            extent[0] +
            ',"ymin":' +
            extent[1] +
            ',"xmax":' +
            extent[2] +
            ',"ymax":' +
            extent[3] +
            '}',
        ) +
        '&geometryType=esriGeometryEnvelope&inSR=' +
        srid +
        '&outFields=*' +
        '&outSR=' +
        srid
      );
    },
    strategy: options.strategy ?? tileStrategy(createXYZ({ tileSize: 512 })),
  });
}
